export default __webpack_public_path__ + "static/media/home-page-new-dashboards.58313f97.png";